import React from "react";

const clientsListColumn = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Label",
    dataIndex: "label",
    key: "label",
  },
  {
    title: "IOC ID",
    dataIndex: "ioc_id",
    key: "ioc_id",
  },
  {
    title: "IOC Label",
    dataIndex: "ioc_label",
    key: "ioc_label",
  },
  {
    title: "Network ID",
    dataIndex: "network_id",
    key: "network_id",
    render: (text, record, index) => {
      const { network_id } = record;

      if(!network_id) return null;
      return (network_id.map((networkId, index) =>
        <span>{networkId} {index < network_id.length - 1 ? ',' : ''} </span>))
    }
  },
];

export default clientsListColumn;



// WEBPACK FOOTER //
// src/containers/admin/clients/ClientsList.utils.js